module.exports = __webpack_public_path__ + "static/media/camera1.da5b59ab.aac";